module.exports = __webpack_public_path__ + "media/images/icons/leaf-d5273592b41dc6e9c7f062f95d998773.svg";